import { render, staticRenderFns } from "./ImportShelf.vue?vue&type=template&id=6dcffe84&scoped=true"
import script from "./ImportShelf.vue?vue&type=script&lang=js"
export * from "./ImportShelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcffe84",
  null
  
)

export default component.exports